import { DMS_MODULE } from './constants';
import { menu } from './menu';
import { router } from './router';

export const Ciselniky = {
	name: DMS_MODULE,
	router,
	menu,
};
